export default "__VITE_ASSET__ChB3GjWF__"